import { onMounted, ref } from "vue";
import { useEventListener, useMutationObserver } from "@vueuse/core";
import { useHostElement } from "#ce/composables/useHostElement";

/** Reports whether any element assigned to `slot` is shown, following its `hidden` attribute as it changes. */
export function useSlottedVisibility(slot) {
  const host = useHostElement();
  const visible = ref(false);

  function measure() {
    visible.value = slot.value?.assignedElements().some((element) => !element.hidden) ?? false;
  }

  useEventListener(slot, "slotchange", measure);
  useMutationObserver(host, measure, { attributes: true, attributeFilter: ["hidden"], subtree: true, childList: true });
  onMounted(measure);

  return { visible };
}
